import { FinancingProcessBrEventType } from '@indigo-ag/schema';
import i18next from 'core/i18n';

export const financingBREventTypesTranslations: { [key in FinancingProcessBrEventType]: string } = {
  [FinancingProcessBrEventType.PHASE_1_APPROVED]: i18next.t('phase1Approved'),
  [FinancingProcessBrEventType.PHASE_1_DENIED]: i18next.t('phase1Denied'),
  [FinancingProcessBrEventType.PHASE_1_COPIED]: i18next.t('phase1Copied'),
  [FinancingProcessBrEventType.PHASE_1_AWAITING_MANAGER_APPROVAL]: i18next.t('analysisSentToCreditManager'),
  [FinancingProcessBrEventType.PHASE_2_STARTED]: i18next.t('phase2Started'),
  [FinancingProcessBrEventType.PHASE_2_APPROVED]: i18next.t('phase2Approved'),
  [FinancingProcessBrEventType.PHASE_2_DENIED]: i18next.t('phase2Denied'),
  [FinancingProcessBrEventType.PHASE_2_WAITING_COMMITTEE_DECISION]: i18next.t('phase2WaitingCommittee'),
  [FinancingProcessBrEventType.PHASE_2_PENDING_ACTIVATION]: i18next.t('phase2PendingActivation'),
  [FinancingProcessBrEventType.PHASE_2_ON_HOLD]: `${i18next.t('phase')} 2 ${i18next.t('onHold')}`,
  [FinancingProcessBrEventType.PHASE_2_AWAITING_COMMERCIAL_DEAL]: `${i18next.t('phase')} 2  ${i18next.t(
    'awaitingCommercialDeal'
  )}`,
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_SENT]: `${i18next.t('collateralAnalysis')} ${i18next.t(
    'markedComplete'
  )}`,
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_ON_HOLD]: `${i18next.t('collateralAnalysis')} ${i18next.t(
    'onHold'
  )}`,
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_RESUMED]: `${i18next.t('collateralAnalysis')} ${i18next.t(
    'resumed'
  )}`,
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_APPROVED]: i18next.t('analysisApproved', { subject: 'collateral' }),
  [FinancingProcessBrEventType.COLLATERAL_CRP_SENT]: i18next.t('cprSent'),
  [FinancingProcessBrEventType.COLLATERAL_CRP_SENT_BACK_FOR_REVISION]: i18next.t('cprSentBack'),
  [FinancingProcessBrEventType.COLLATERAL_CRP_APPROVED]: i18next.t('cprApproved'),
  [FinancingProcessBrEventType.CREDIT_MARKED_AS_COMPLETE]: `${i18next.t('creditAnalysis')} ${i18next.t(
    'markedComplete'
  )}`,
  [FinancingProcessBrEventType.CREDIT_ANALYSIS_ON_HOLD]: `${i18next.t('creditAnalysis')} ${i18next.t('onHold')}`,
  [FinancingProcessBrEventType.CREDIT_ANALYSIS_RESUMED]: `${i18next.t('creditAnalysis')} ${i18next.t('resumed')}`,
  [FinancingProcessBrEventType.CREDIT_APPROVAL_CREDIT_ANALYST_APPROVED]: i18next.t(
    'creditApprovalApprovedByCreditAnalyst'
  ),
  [FinancingProcessBrEventType.CREDIT_APPROVAL_DENIED]: i18next.t('creditApprovalDenied'),
  [FinancingProcessBrEventType.CREDIT_APPROVAL_SENT_TO_CREDIT_MANAGER]: i18next.t(
    'creditApprovalEscalatedToCreditManager'
  ),
  [FinancingProcessBrEventType.CREDIT_APPROVAL_CREDIT_MANAGER_APPROVED]: i18next.t(
    'creditApprovalApprovedByCreditManager'
  ),
  [FinancingProcessBrEventType.CREDIT_APPROVAL_RESET]: i18next.t('creditApprovalReset'),
  [FinancingProcessBrEventType.OTHER]: i18next.t('other'),
  [FinancingProcessBrEventType.DOCUMENT_REQUEST_CREATED]: i18next.t('documentRequestCreated'),
  [FinancingProcessBrEventType.DOCUMENT_REQUEST_APPROVED]: i18next.t('documentRequestApproved'),
  [FinancingProcessBrEventType.DOCUMENT_REQUEST_DENIED]: i18next.t('documentRequestDenied'),
  [FinancingProcessBrEventType.DOCUMENT_REQUEST_DELETED]: i18next.t('documentRequestDeleted'),
  [FinancingProcessBrEventType.DOCUMENT_REQUEST_REVISION_REQUIRED]: i18next.t('documentRequestRevisionRequired'),
  [FinancingProcessBrEventType.DOCUMENT_REQUEST_SUBMISSION_RECEIVED]: i18next.t('growerSubmittedFiles'),
  [FinancingProcessBrEventType.TIMELINE_COMMENT]: i18next.t('notes'),
  [FinancingProcessBrEventType.PHASE_3_STARTED]: i18next.t('phase3Started'),
  [FinancingProcessBrEventType.PHASE_3_DENIED]: i18next.t('phase3Denied'),
  [FinancingProcessBrEventType.PHASE_3_DRAFT_SENT_TO_COMMERCIAL]: i18next.t('phase3DraftSentToCommercial'),
  [FinancingProcessBrEventType.PHASE_3_REVIEWING_SIGNED_DOCUMENTS]: i18next.t('phase3ReviewingDocuments'),
  [FinancingProcessBrEventType.PHASE_3_SIGNED_DOCUMENTS_APPROVED]: i18next.t('phase3SignedDocumentsApproved'),
  [FinancingProcessBrEventType.PHASE_3_SIGNED_DOCUMENTS_DENIED]: i18next.t('phase3SignedDocumentsDenied'),
  [FinancingProcessBrEventType.PHASE_3_SIGNED_DOCUMENTS_SENT_TO_CREDIT_TEAM]: i18next.t(
    'phase3SignedDocumentsSentToCreditTeam'
  ),
  [FinancingProcessBrEventType.PHASE_3_SIGNED_DOCUMENTS_RETURNED_TO_COLLATERAL]: i18next.t(
    'phase3SignedDocumentsReturnedToCollateral'
  ),
  [FinancingProcessBrEventType.PHASE_3_SIGNED_DOCUMENTS_SENT_TO_CREDIT_MANAGER]: i18next.t(
    'phase3SignedDocumentsSentToCreditManager'
  ),
  [FinancingProcessBrEventType.PHASE_3_CREATING_AMENDMENT]: `${i18next.t('phase')} 3 - ${i18next.t(
    'creatingAmendment'
  )}`,
  [FinancingProcessBrEventType.PHASE_3_DIGITAL_SIGNATURE_REQUESTED]: `${i18next.t('phase')} 3 - ${i18next.t(
    'digitalSignatureRequested'
  )}`,
  [FinancingProcessBrEventType.PHASE_3_PHYSICAL_SIGNATURE_REQUESTED]: `${i18next.t('phase')} 3 - ${i18next.t(
    'physicalSignatureRequested'
  )}`,
  [FinancingProcessBrEventType.PHASE_3_AMENDMENT_SIGNED]: `${i18next.t('phase')} 3 - ${i18next.t('amendmentSigned')}`,
  [FinancingProcessBrEventType.PHASE_3_ON_HOLD]: `${i18next.t('phase')} 3 ${i18next.t('onHold')}`,
  [FinancingProcessBrEventType.FINANCING_PROCESS_COMPLETED]: i18next.t('financingProcessCompleted'),
  [FinancingProcessBrEventType.FINANCING_PROCESS_COMPLETED_MANUALLY]: i18next.t('financingProcessCompletedManually'),
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_DENIED]: i18next.t('analysisDenied', { subject: 'collateral' }),
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_SENT_TO_CREDIT_MANAGER]: i18next.t('analysisSentToCreditManager', {
    subject: 'collateral'
  }),
  [FinancingProcessBrEventType.COLLATERAL_ANALYSIS_RESTARTED]: `${i18next.t('collateralAnalysis')} ${i18next.t(
    'restarted'
  )}`,
  [FinancingProcessBrEventType.CREDIT_ANALYSIS_APPROVED]: i18next.t('analysisApproved', { subject: 'credit' }),
  [FinancingProcessBrEventType.CREDIT_ANALYSIS_DENIED]: i18next.t('analysisDenied', { subject: 'credit' }),
  [FinancingProcessBrEventType.CREDIT_ANALYSIS_SENT_TO_CREDIT_MANAGER]: i18next.t('analysisSentToCreditManager', {
    subject: 'credit'
  }),
  [FinancingProcessBrEventType.CREDIT_ANALYSIS_RESTARTED]: `${i18next.t('creditAnalysis')} ${i18next.t('restarted')}`,
  [FinancingProcessBrEventType.FIELD_MONITORING_COMPLETED]: `${i18next.t('fieldMonitoring')} ${i18next.t('completed')}`,
  [FinancingProcessBrEventType.FIELD_MONITORING_RESTARTED]: `${i18next.t('fieldMonitoring')} ${i18next.t('restarted')}`,
  [FinancingProcessBrEventType.FIELD_MONITORING_ON_HOLD]: `${i18next.t('fieldMonitoring')} ${i18next.t('onHold')}`,
  [FinancingProcessBrEventType.FIELD_MONITORING_RESUMED]: `${i18next.t('fieldMonitoring')} ${i18next.t('resumed')}`,
  [FinancingProcessBrEventType.PHASE_4_AWAITING_ASSIGNMENT]: `${i18next.t('phase')} 4 ${i18next.t(
    'awaitingAssignment'
  )}`,
  [FinancingProcessBrEventType.PHASE_4_ASSIGNED_TO_FUND]: `${i18next.t('phase')} 4 ${i18next.t('fundAssigned')}`,
  [FinancingProcessBrEventType.PHASE_4_RECEIVED_BY_FUND]: `${i18next.t('phase')} 4 ${i18next.t('receivedByFund')}`,
  [FinancingProcessBrEventType.PHASE_4_AWAITING_MANAGER_APPROVAL]: `${i18next.t('phase')} 4 ${i18next.t(
    'awaitingManagerApproval'
  )}`,
  [FinancingProcessBrEventType.PHASE_4_MANAGER_DENIED]: `${i18next.t('phase')} 4 ${i18next.t('managerDenied')}`,
  [FinancingProcessBrEventType.PHASE_4_SUBMITTED_MINUTA]: `${i18next.t('phase')} 4 ${i18next.t('submittedMinuta')}`,
  [FinancingProcessBrEventType.PHASE_4_ADDED_TO_GROUP]: `${i18next.t('phase')} 4 ${i18next.t('addedToGroup')}`,
  [FinancingProcessBrEventType.PHASE_4_REMOVED_FROM_GROUP]: `${i18next.t('phase')} 4 ${i18next.t('removedFromGroup')}`,
  [FinancingProcessBrEventType.PHASE_4_ON_HOLD]: `${i18next.t('phase')} 4 ${i18next.t('onHold')}`,
  [FinancingProcessBrEventType.PHASE_3_PHYSICAL_DOCUMENTS_RECEIVED]: `${i18next.t('physicalDocumentsReceived')}`,
  [FinancingProcessBrEventType.MARKED_AS_PRIORITY]: `AgFinance - ${i18next.t('markedAsPriority')}`,
  [FinancingProcessBrEventType.UNMARKED_AS_PRIORITY]: `AgFinance - ${i18next.t('unMarkedAsPriority')}`,
  [FinancingProcessBrEventType.CONTACT_RISK_CLASSIFICATION_ADDED]: `${i18next.t('contactRiskClassificationAdded')}`,
  [FinancingProcessBrEventType.IMPORTED_EXCEPTIONS_AND_CONDITIONALS]: i18next.t('importedExceptionsAndConditionals'),
  [FinancingProcessBrEventType.ADD_EXCEPTION]: i18next.t('updatedExceptions'),
  [FinancingProcessBrEventType.ADD_CONDITIONAL]: i18next.t('updatedConditionals'),
  [FinancingProcessBrEventType.PHASE_3_APPROVED_CONDITIONALS]: i18next.t('approvedConditionals')
};
